// src/pages/AdminLogin.js

import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const AdminLogin = ({ setLoggedIn }) => {

    const [formData, setFormData] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const [adminMode, setAdminMode] = useState(false);
    const [requests, setRequests] = useState([]);

    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const fetchRequests = async () => {
        try {
            const res = await axios.get('https://streamsrv.n-tools.info/api/admin/pending-registrations');
            setRequests(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleApprove = async (id) => {
        await axios.post(`https://streamsrv.n-tools.info/api/admin/approve/${id}`);
        fetchRequests();
    };

    const handleReject = async (id) => {
        await axios.post(`https://streamsrv.n-tools.info/api/admin/reject/${id}`);
        fetchRequests();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {

            const response = await axios.post(
                'https://streamsrv.n-tools.info/api/auth/login',
                formData
            );

            if (response.data.success && response.data.role === "admin") {
                localStorage.setItem("adminAuth", "true");
                // IMPORTANT
                setAdminMode(true);
                fetchRequests();
            } else {
                setError("Admin access required.");
            }

        } catch (err) {
            setError(err.response?.data?.message || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {

        localStorage.removeItem("adminAuth");
        navigate("/home");
    };

    // ================= ADMIN UI =================

    if (adminMode) {
        return (
            <div className="admin-login-container">
                <div className="login-box">
                    <h2>Registration Control Panel</h2>
                    <button
                        className="back-btn"
                        onClick={handleBack}
                    >
                        ← Back
                    </button>
                    {requests.length === 0 && (
                        <p>No Pending Requests</p>
                    )}
                    {requests.map((req) => (
                        <div key={req.id} className="request-card">
                            <div>
                                <strong>{req.username}</strong>
                                <p>{req.email}</p>
                            </div>
                            <div className="request-actions">
                                <button
                                    className="approve-btn"
                                    onClick={() => handleApprove(req.id)}
                                >
                                    Approve
                                </button>
                                <button
                                    className="reject-btn"
                                    onClick={() => handleReject(req.id)}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // ================= LOGIN UI =================

    return (
        <div className="admin-login-container">
            <div className="login-box">
                <div className="login-header">
                    <div className="admin-icon">🛡️</div>
                    <h2>Administrator Login</h2>
                    <p>Secure access for system management</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label>Admin Username</label>
                        <input
                            type="text"
                            name="username"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    {error && <div className="error-msg">{error}</div>}
                    <button
                        type="submit"
                        className="admin-btn"
                        disabled={loading}
                    >
                        {loading ? "Verifying..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;